import { call, put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import {
  type DashboardActions,
  InternalFolderActions as Internal,
} from '../../actions'
import { selectWorkspaceFolders } from '../../selectors'
import type { WorkspaceItem } from '../../types'
import { getOrdersDiff, swapItems } from '../../utils'

export function* move({
  payload: { workspaceId, direction, id },
}: ReturnType<typeof DashboardActions.folders.move>) {
  const folders: WorkspaceItem[] = yield select(
    selectWorkspaceFolders(workspaceId)
  )

  const index = folders.findIndex((f) => f.id === id)
  const newIndex = index + direction

  const event =
    direction > 0
      ? GtmTriggerName.DASHBOARD_FOLDER_DOWN
      : GtmTriggerName.DASHBOARD_FOLDER_UP

  sendGtmEvent(event)

  const newFolders = swapItems(folders, index, newIndex)

  const orders = getOrdersDiff(newFolders)

  yield put(Internal.set({ workspaceId, folders: newFolders }))

  yield call(NestClient.folders.order, workspaceId, { orders })
}
